(function() {
  var BRAND_REGEX = /(^|[^@#/\w\.])((?:ro|\u0440\u043e)[\s\.](?:ro|\u0440\u043e))(?!\.(?:crafts|com|ua|org)|\w)/i;

  function formatBrandTextNodes(root) {
    if (!root) return;
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (!node || !node.nodeValue || !BRAND_REGEX.test(node.nodeValue)) {
            return NodeFilter.FILTER_REJECT;
          }
          var parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          var tag = parent.tagName;
          if (
            tag === 'SCRIPT' ||
            tag === 'STYLE' ||
            tag === 'TEXTAREA' ||
            tag === 'INPUT' ||
            tag === 'SELECT' ||
            tag === 'OPTION' ||
            tag === 'CODE' ||
            tag === 'PRE' ||
            tag === 'SVG' ||
            tag === 'NOSCRIPT' ||
            parent.closest('.roro-navbar') ||
            // Texto que no se ve (el h1 de la home): la insignia no aporta nada
            // y cambiaría «ro.ro crafts» por «ro ro» para Google y lectores.
            parent.closest('.visually-hidden') ||
            parent.closest('.roro-brand-text') ||
            parent.closest('.roro-brand-logo') ||
            parent.closest('.roro-brand-logo-inline')
          ) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var nodesToReplace = [];
    while (walker.nextNode()) {
      nodesToReplace.push(walker.currentNode);
    }

    nodesToReplace.forEach(function(node) {
      var parent = node.parentNode;
      if (!parent) return;
      var text = node.nodeValue;
      var globalRegex = new RegExp(BRAND_REGEX.source, 'gi');
      var match;
      var lastIndex = 0;
      var fragment = document.createDocumentFragment();

      while ((match = globalRegex.exec(text)) !== null) {
        var prefix = match[1] || '';
        var matchStart = match.index + prefix.length;
        var matchEnd = matchStart + match[2].length;

        if (matchStart > lastIndex) {
          fragment.appendChild(document.createTextNode(text.substring(lastIndex, matchStart)));
        }

        var span = document.createElement('span');
        span.className = 'roro-brand-text';
        span.textContent = 'ro ro';
        fragment.appendChild(span);

        lastIndex = matchEnd;
      }

      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
      }

      parent.replaceChild(fragment, node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      formatBrandTextNodes(document.body);
    });
  } else {
    formatBrandTextNodes(document.body);
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === Node.ELEMENT_NODE) {
            formatBrandTextNodes(node);
          }
        }
      }
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
